var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _line, _line2, _line3, _line4, _line5, _g9, _g10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 130",
    style: {
      enableBackground: "new 0 0 170 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#32324E;}\n\t.st1{fill:none;stroke:#32324E;stroke-width:4;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#32324E;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.24,11c10.41,0,18.88,8.47,18.88,18.88v1.72c-2.8-1.55-5.31-3.6-7.42-6.06l-2.53-2.95l-3.02,2.44 c-4.85,3.91-10.7,5.98-16.93,5.98c-1.06,0-2.13-0.07-3.28-0.21l-1.47-0.18l-1.23,0.83c-0.61,0.41-1.24,0.8-1.88,1.15v-2.71 C26.36,19.47,34.83,11,45.24,11 M45.24,7C32.6,7,22.36,17.25,22.36,29.88v8.75c2.91-0.9,5.64-2.21,8.11-3.87 C31.7,34.91,32.96,35,34.23,35c7.36,0,14.12-2.57,19.44-6.86c3.77,4.41,8.77,7.74,14.46,9.49v-7.74C68.12,17.25,57.88,7,45.24,7 L45.24,7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.79,68.49c3.48,1.2,10.9,3.81,18.32,6.77c3.08,1.23,8.9,5.73,8.9,13.92V107h-75V89.19 c0-8.2,5.82-12.69,8.9-13.92c7.36-2.94,14.8-5.38,18.32-6.49l7.15,6.24l2.52,2.2l2.61-2.09L55.79,68.49 M55,64l-10,8l-8.84-7.71 c0,0-10.38,3.11-20.75,7.26C10.22,73.63,4,79.85,4,89.19V111h83V89.19c0-9.34-6.22-15.56-11.41-17.64C65.21,67.4,55,64,55,64L55,64 z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "37,60 37,67.5 45.39,74.36 54,67.56 54,60  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151,33c4.41,0,8,3.59,8,8v37c0,4.41-3.59,8-8,8H93c-4.41,0-8-3.59-8-8V41c0-4.41,3.59-8,8-8H151 M151,29H93 c-6.63,0-12,5.37-12,12v37c0,6.63,5.37,12,12,12h58c6.63,0,12-5.37,12-12V41C163,34.37,157.63,29,151,29L151,29z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111,99V73c0-6.07,4.93-11,11-11s11,4.93,11,11v26H111z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122,64c4.96,0,9,4.04,9,9v24h-18V73C113,68.04,117.04,64,122,64 M122,60c-7.18,0-13,5.82-13,13v28h26V73 C135,65.82,129.18,60,122,60L122,60z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.21,36.01L28.04,36c0,0,0,0-0.01,0c-2.8,0-5.04,2.24-5.04,5s2.24,5,5,5l0.29-0.02"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.08,45.99L62.25,46c0,0,0,0,0.01,0c2.8,0,5.04-2.24,5.04-5s-2.24-5-5-5l-0.29,0.02"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.24,29.42c1.81,1.71,3.79,3.21,5.94,4.51v13.12c0,7.69-6.26,13.95-13.95,13.95s-13.95-6.26-13.95-13.95 V35.01c0.07-0.04,0.14-0.09,0.21-0.13c0.95,0.08,1.88,0.12,2.79,0.12C41.02,35,47.62,33.04,53.24,29.42 M53.73,24.14 C48.41,28.43,41.65,31,34.29,31c-1.27,0-2.53-0.09-3.76-0.24c-1.03,0.69-2.12,1.31-3.24,1.88v14.41c0,9.91,8.04,17.95,17.95,17.95 c9.91,0,17.95-8.04,17.95-17.95V31.58C59.57,29.73,56.35,27.2,53.73,24.14L53.73,24.14z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 6,
    y1: 119,
    x2: 166,
    y2: 119
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 6,
    y1: 109,
    x2: 166,
    y2: 109
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 107.5,
    y1: 48.5,
    x2: 135,
    y2: 48.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 23.25,
    y1: 110.25,
    x2: 23.25,
    y2: 94
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 68.25,
    y1: 110.25,
    x2: 68.25,
    y2: 94
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95,109v-6.71c0-2.92,2.38-5.29,5.29-5.29h43.41c2.92,0,5.29,2.38,5.29,5.29V109H95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.7,99c1.82,0,3.3,1.48,3.3,3.3v4.7H97v-4.7c0-1.82,1.48-3.3,3.3-3.3H143.7 M143.7,95h-43.4 c-4.03,0-7.3,3.27-7.3,7.3v8.7h58v-8.7C151,98.27,147.73,95,143.7,95L143.7,95z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85,109v-6.93c0-2.21,1.79-4,4-4h2c2.21,0,4,1.79,4,4V109H85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91,100.07c1.1,0,2,0.9,2,2V107h-6v-4.93c0-1.1,0.9-2,2-2H91 M91,96.07h-2c-3.31,0-6,2.69-6,6V111h14v-8.93 C97,98.75,94.31,96.07,91,96.07L91,96.07z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdministration);
export default __webpack_public_path__ + "static/media/icon_administration.f3adb0ae69a70ff5282ff504f3a65789.svg";
export { ForwardRef as ReactComponent };